import api from './api';

export const registerNotificationToken = async (token: string, deviceType: string) => {
  try {
    await api.post('/notifications/register-token', { token, deviceType });
  } catch (error) {
    console.error('Failed to register notification token:', error);
    throw error; // Re-throw the error
  }
};

export const unregisterNotificationToken = async (token: string) => {
  try {
    await api.post('/notifications/unregister-token', { token });
  } catch (error) {
    console.error('Failed to unregister notification token:', error);
    throw error; // Re-throw the error
  }
};

export const sendNotificationToUser = async (userId: string, title: string, body: string) => {
    await api.post('/notifications/send-to-user', { userId, title, body });
};

export const sendTestEmailToUser = async (userId: string, subject: string, body: string) => {
    await api.post('/notifications/send-email-to-user', { userId, subject, body });
};
